import api from '@/services/api';

const applyDiscountToInvoice = (invoiceId, coupon) => api()
  .patch(`invoices/${invoiceId}/apply_discount/${coupon}`);

const applyDiscountToInvoiceItem = (invoiceItemId, coupon) => api()
  .patch(`invoicesitems/${invoiceItemId}/apply_discount/${coupon}`);

const changeInvoiceItemPlan = (invoiceItemId, planName) => api()
  .patch(`invoicesitems/${invoiceItemId}/change_plan/${planName}`);

const changeInvoicePlan = (invoiceId, planName) => api()
  .patch(`invoices/${invoiceId}/change_plan/${planName.toUpperCase()}`);

const createInvoiceFromOrder = (orderId) => api()
  .post('invoices', { orderId });

const getSubscriptionInvoiceItems = (subscriptionId) => api()
  .get(`invoicesitems?filters=subscriptionId:eq:${subscriptionId}&sort=-createdAt`);

const findAllInvoiceItems = () => api()
  .get('invoicesitems?sort=-createdAt');

const getInvoice = (invoiceId) => api()
  .get(`invoices/${invoiceId}`);

const findInvoiceItemById = (invoiceItemId) => api()
  .get(`invoicesitems/${invoiceItemId}`);

const findInvoiceItemPaymentById = (invoiceItemId) => api()
  .get(`invoicesitems/${invoiceItemId}/payments`);

const findInvoiceItemPreviewById = (invoiceItemId) => api()
  .get(`invoicesitems/${invoiceItemId}/preview`);

export {
  applyDiscountToInvoice,
  applyDiscountToInvoiceItem,
  changeInvoiceItemPlan,
  changeInvoicePlan,
  createInvoiceFromOrder,
  findAllInvoiceItems,
  getInvoice,
  findInvoiceItemById,
  findInvoiceItemPaymentById,
  getSubscriptionInvoiceItems,
  findInvoiceItemPreviewById,
};
